/**
 * Configuration for the "What's New" section on the homepage
 */

import { Language } from "../../context";
import whats_new_en_json from "./whatsnew-en.json";
import whats_new_tc_json from "./whatsnew-tc.json";

export type WhatsNewData = {
  title: string;
  date: string;
  thumb: string;
  imagePathSwitch?: string;
  url: string;
  target: "_self" | "_blank";
};

const processWhatsNewJson = (jsonData: any[]): WhatsNewData[] => {
  return jsonData?.map((item) => ({
    title: item?.title ?? "",
    date: item?.date ?? "",
    thumb: item?.thumb ?? "",
    url: item?.url ?? "",
    target: item?.target as "_self" | "_blank",
  }));
};

const WhatsNewConfiguration_en: WhatsNewData[] =
  processWhatsNewJson(whats_new_en_json);

const WhatsNewConfiguration_tc: WhatsNewData[] =
  processWhatsNewJson(whats_new_tc_json);

const WhatsNewConfiguration_sc: WhatsNewData[] =
  processWhatsNewJson(whats_new_tc_json);

export const whatsNewLanguageMap: Record<Language, WhatsNewData[]> = {
  [Language.EN]: WhatsNewConfiguration_en,
  [Language.TC]: WhatsNewConfiguration_tc,
  [Language.SC]: WhatsNewConfiguration_sc,
};
